import { config } from "../config.js";

export const BLOOMERANG_CONFIG = {
  paymentAdapter: config.paymentAdapter || 'mock',
  formId: config.bloomerangFormId || '398451712',
  processorId: '173169665',
  publicKey: 'pub_068fd680-61e5-11e3-a756-02a718d18e56',
  stripePublishableKey: 'pk_live_iZYXFefCkt380zu63aqUIo7y',
  stripeAccountId: 'acct_1KgVYGQaYFiWsT6K',
  recaptchaV3SiteKey: '6LfKq4osAAAAAChjJ85FoLL8h-0iBcTRFfop43QX',
  recaptchaV2SiteKey: '6Lf4cIwsAAAAAE-kFYGw7qPZFlRCGZIIgF8jeNDa',
  bloomerangJsUrl: 'https://crm.bloomerang.co/Content/Scripts/Api/Bloomerang-v2.js?nocache=1770166697',
  jqueryUrl: 'https://code.jquery.com/jquery-3.7.1.min.js',
  transactionFee: 0.3,
  transactionFeeRate: 0.032,
  yardSignFieldId: '8546304',
  yardSignOptions: {
    'I Step Up for Teachers': '8547329',
    'Congratulations 2026 Graduate': '8547328',
  },
};
